//axios
import axios from "axios";

// Sign-in tokens are HttpOnly cookies now; the browser never sends an
// Authorization header. Kept so old callers can still "clear" it.
export default function SetToken() {
  delete axios.defaults.headers.common["Authorization"];
}
